import React from 'react';
import { Navigate } from 'react-router-dom';
import { Mail, LockKeyhole, AlertCircle } from 'lucide-react';
import LoginForm from '../../components/auth/LoginForm';
import { useAuth } from '../../hooks/useAuth';
import logo from '../../assets/images/logo/logo.png';

const Login: React.FC = () => {
  const { isAuthenticated } = useAuth();

  // Redirect if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col justify-center bg-gray-50">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src={logo}
            alt="My Express Limited Logo"
            className="mx-auto h-16 w-auto"
          />
          <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
            Welcome back
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Sign in to your admin account
          </p>
        </div>

       
        

        {/* Main Card */}
        <div className="bg-white mx-4 py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <LoginForm />

          {/* Support Links */}
          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="bg-white px-2 text-gray-500">Need help?</span>
              </div>
            </div>

            <div className="mt-6 flex flex-col gap-4">
              <button
                type="button"
                onClick={() => window.location.href = '/support'}
                className="text-sm text-brand-blue-600 hover:text-brand-blue-500 
                  font-medium flex items-center justify-center"
              >
                <Mail className="h-4 w-4 mr-2" />
                Contact Support
              </button>
              
              <button
                type="button"
                onClick={() => window.location.href = '/auth/reset-password'}
                className="text-sm text-brand-blue-600 hover:text-brand-blue-500 
                  font-medium flex items-center justify-center"
              >
                <LockKeyhole className="h-4 w-4 mr-2" />
                Reset Password
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} My Express Limited. All rights reserved.
          </p>
          <div className="mt-2 flex justify-center space-x-4 text-sm">
            <button
              type="button"
              onClick={() => window.location.href = '/privacy'}
              className="text-gray-500 hover:text-gray-900 transition-colors"
            >
              Privacy Policy
            </button>
            <span className="text-gray-300">|</span>
            <button
              type="button"
              onClick={() => window.location.href = '/terms'}
              className="text-gray-500 hover:text-gray-900 transition-colors"
            >
              Terms of Service
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Login;